/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAvailableNotificationsResponseData } from './genericApiResponseAvailableNotificationsResponseData';
import type { GenericApiResponseAvailableNotificationsResponseMessage } from './genericApiResponseAvailableNotificationsResponseMessage';
import type { GenericApiResponseAvailableNotificationsResponsePagination } from './genericApiResponseAvailableNotificationsResponsePagination';
import type { GenericApiResponseAvailableNotificationsResponseError } from './genericApiResponseAvailableNotificationsResponseError';

export interface GenericApiResponseAvailableNotificationsResponse {
  data?: GenericApiResponseAvailableNotificationsResponseData;
  message?: GenericApiResponseAvailableNotificationsResponseMessage;
  pagination?: GenericApiResponseAvailableNotificationsResponsePagination;
  error?: GenericApiResponseAvailableNotificationsResponseError;
  statusCode?: number;
}
